<script lang="ts">
</script>

<img src="/assets/brand/points.svg" alt="JungleTV Points" title="JungleTV Points" class="inline align-baseline" />

<style>
    img {
        height: 0.92em;
        margin-bottom: -0.1em;
    }
</style>
